import { Component } from 'react'
import { toast } from 'react-toastify'
import { IClientUID } from '../../../api/clients'
import classNames from 'classnames'
import { flashDevice } from '../../../api/0x0001/flash-device'
import { getString } from '../../../locale'

type Props = {
    clientId: IClientUID
}

type State = {
    flashing: boolean
}

class FlashDeviceTab extends Component<Props, State> {
    state: State = {
        flashing: false
    }

    handleFlashDevice = async () => {
        this.setState({ flashing: true })
        try {
            await flashDevice(this.props.clientId)
            toast.success(getString('flash_device.flash_complete'))
        } catch (error) {
            toast.error(getString('flash_device.flash_failed'))
        } finally {
            this.setState({ flashing: false })
        }
    }

    render() {
        return (
            <div>
                {this.renderFlashDeviceButton()}
            </div>
        )
    }

    renderFlashDeviceButton() {
        const { flashing } = this.state
        return <button
            onClick={this.handleFlashDevice as any}
            // onTouchStart={pressCallback as any}
            // onTouchEnd={releaseCallback as any}
            // onMouseDown={pressCallback as any}
            // onMouseUp={releaseCallback as any}
            // onMouseLeave={releaseCallback as any}
            className={classNames(
                `group py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-501`,
            )}
        >
            {getString(flashing ? 'flash_device.flashing' : 'flash_device.begin_flash')}
        </button>
    }
}

export default FlashDeviceTab
